export class KeyboardKey {}
